<template>
    <div class="contenedor_modal" v-shortkey="['esc']" @shortkey="cerrar">

        <div class="contenedor_modal_cuerpo">
            <div class="contenedor_modal_cabecera">
                <button type="button" class="btn btn-sm btn-danger" @click="cerrar"><i
                        class="fas fa-times"></i></button>
            </div>
            <b-container fluid>
                <b-row>
                    <div class="col-sm-12 mt-2">
                        <h3>
                            Buscar productos
                        </h3>
                    </div>

                    <div class="col-sm-12 mt-3">
                        <label for="" class="form-label">Nombre producto</label>
                        <input type="text" class="form-control form-control-sm" placeholder="Presiona Enter para buscar" v-model="nombre" @keyup.enter="buscar" ref="inputNombre">
                    </div>

                    <div class="col-sm-12 mt-3 mb-3">
                        <div class="marco-lista-productos-encotrados">
                            <div v-if="cargando" class="text-center py-5">
                                <div class="spinner-border text-primary" role="status">
                                    <span class="sr-only">Cargando...</span>
                                </div>
                                <p class="mt-2">Buscando productos...</p>
                            </div>
                            <table v-else class="table table-sm table-striped table-bordered" style="font-size: 10px;">
                                <thead>
                                    <tr>
                                        <th style="width: 70%;">
                                            Nombre
                                        </th>
                                        <th style="width: 20%;text-align: center;">
                                            Sucursal
                                        </th>
                                        <th style="width: 10%;text-align: center;">
                                            ...
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in resultados" :key="index"
                                        @dblclick="articulo_seleccionado(item)">
                                        <td>
                                            {{ item.nombre }}
                                        </td>
                                        <td>
                                            {{ item.nombre_sucursal }}
                                        </td>
                                        <td style="text-align: center;">
                                            <button type="button" style="font-size: 9px;"
                                                class="btn btn-sm btn-outline-dark"
                                                @click="articulo_seleccionado(item)"><i
                                                    class="fas fa-check"></i></button>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
import { minix } from '@/components/functions/alertas';
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
    name: 'ModalBusquedaProductos',
    props: ['sucursal_seleccionada'],
    computed: {
        ...mapState(['id_empresa_seleccionada'])
    },
    data() {
        return {
            nombre: '',
            resultados: [],
            cargando: false,
        }
    },
    mounted() {
        this.$refs.inputNombre.focus()
    },
    methods: {
        cerrar() {
            this.set_modal_buscar_productos(false)
        },
        articulo_seleccionado(item) {
            console.log('Artículo seleccionado:', item)
            // Aquí va tu lógica
        },
        async buscar() {
            if (this.nombre == '' || this.nombre == null || this.nombre == undefined) {
                minix({ icon: 'error', mensaje: 'Ingrese el nombre del producto', tiempo: 2000 })
                return
            }

            this.cargando = true
            this.resultados = []

            let f = {
                api: `articulos/c/buscar_m?referencia=${this.nombre.trim()}&empresa=${this.id_empresa_seleccionada}&sucursal=${this.sucursal_seleccionada}`
            }

            let r = await this.obtener_data(f)

            this.cargando = false

            if (r.length == 0) {
                minix({ icon: 'warning', mensaje: 'No se encontraron registros', tiempo: 2000 })
            } else {
                this.resultados = r
            }
        },
        articulo_seleccionado(item) {
            this.set_articulo_busqueda_seleccionado(item)
            this.$emit('colocar')
            this.cerrar()
        },
        ...mapMutations(['set_modal_buscar_productos', 'set_articulo_busqueda_seleccionado']),
        ...mapActions(['obtener_data'])
    },
}
/* Notas:
 
--- Para abrir el modal:

 abrir_modal_de_busqueda_de_productos() {
            this.set_modal_buscar_productos(true)
        },


---Agregar esta función para insertar los datos de busqueda necedsarios:

colocar_resultados_de_busqueda() {
    this.existe = true
    this.codigo_producto = this.articulo_busqueda_seleccionado.codigo//r[0].codigo
    this.nombre_producto = this.articulo_busqueda_seleccionado.nombre//r[0].nombre
    this.precio_unitario = this.articulo_busqueda_seleccionado.precio_costo//r[0].precio_costo
    document.getElementById('campo_precio_unitario_entradas').focus()
}

---Insertar el componente de esta manera:

<ModalBusqueda v-if="modal_buscar_productos" v-on:colocar="colocar_resultados_de_busqueda" />


---el mapstate debe ir asi:

['modal_buscar_productos', 'articulo_busqueda_seleccionado']

---mapmutations:

...mapMutations(['set_modal_buscar_productos']),
    */
</script>

<style>
.marco-lista-productos-encotrados {
    width: 100%;
    height: 300px;
    overflow: auto;
}

.marco-lista-productos-encotrados thead th {
    position: sticky;
    top: 0;
    background-color: white;
    z-index: 1;
}
</style>
